import { RightType } from "../../../Global/Base/Rights/RightTypes";
//TODO-rites: comment;
export interface IBasicRightResults {
    get(rightType: RightType): boolean | undefined;

    set(rightType: RightType, value: boolean): this;

    unset(rightType: RightType): this;

    getAdditionalResultInfo(infoType: AdditionalRightResultInfoType): boolean | null;
    setAdditionalResultInfo(infoType: AdditionalRightResultInfoType, value: boolean): this;
}

export enum AdditionalRightResultInfoType {
    disabledFormParent = 1 << 0,
    disabledByItemRights = 1 << 1,
    invisibleFromParent = 1 << 2,
    itemRightsEvaluationSkipped = 1 << 3,
}

export class BasicRightResults implements IBasicRightResults {
    private _rightResultsMap: Map<RightType, boolean> = new Map<RightType, boolean>();
    private _additionalResultInfoMap: Map<AdditionalRightResultInfoType, boolean> = new Map<AdditionalRightResultInfoType, boolean>();

    public get(rightType: RightType): boolean | undefined {
        return this._rightResultsMap.get(rightType);
    }

    public set(rightType: RightType, value: boolean): this {
        this._rightResultsMap.set(rightType, value);

        return this;
    }

    public unset(rightType: RightType): this {
        this._rightResultsMap.delete(rightType);

        return this;
    }

    public getAdditionalResultInfo(infoType: AdditionalRightResultInfoType): boolean | null {
        return this._additionalResultInfoMap.get(infoType) || null;
    }
    public setAdditionalResultInfo(infoType: AdditionalRightResultInfoType, value: boolean = true): this {
        this._additionalResultInfoMap.set(infoType, value);

        return this;
    }
}
